module.exports = __webpack_public_path__ + "img/AM_Banner_Cyber-Week-2022.01e1eb2a.jpg";